import { forwardRef } from "react";
import {
  Group as ReactAriaGroup,
  type GroupProps as ReactAriaGroupProps,
} from "react-aria-components";

export interface NcGroupProps extends ReactAriaGroupProps {
  "aria-label"?: string;
  "aria-labelledby"?: string;
}

const NcGroup = forwardRef<HTMLDivElement, NcGroupProps>(({ children, ...props }, ref) => (
  <ReactAriaGroup data-nc="NcGroup" ref={ref} {...props}>
    {children}
  </ReactAriaGroup>
));

export { NcGroup };
